<template>

    <form ref="escolabox-form-create" v-on:submit.prevent="executeCreate(model)" novalidate>

        <div class="row">

            
					<div class="form-group col-md-12">
                        <div class="clearfix">&nbsp;</div>
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" name="habilitarMonitoramento" class="custom-control-input" v-model="model.habilitarMonitoramento">
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description"> HabilitarMonitoramento?</span>
                        </label>
                    </div>
					<div class="form-group col-md-12">
                        <label for="porteEscolaId">PorteEscolaId</label>
                        <input type="text" class="form-control" name="porteEscolaId" placeholder="PorteEscolaId" v-model="model.porteEscolaId"  />
                    </div>
					<div class="form-group col-md-12">
                        <label for="colaboradorResponsavelId">ColaboradorResponsavelId</label>
                        <input type="text" class="form-control" name="colaboradorResponsavelId" placeholder="ColaboradorResponsavelId" v-model="model.colaboradorResponsavelId" required />
                    </div>
					<div class="form-group col-md-12">
                        <div class="clearfix">&nbsp;</div>
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" name="temModuloConsultivo" class="custom-control-input" v-model="model.temModuloConsultivo">
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description"> TemModuloConsultivo?</span>
                        </label>
                    </div>
					<div class="form-group col-md-12">
                        <div class="clearfix">&nbsp;</div>
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" name="ativo" class="custom-control-input" v-model="model.ativo">
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description"> Ativo?</span>
                        </label>
                    </div>
					<div class="form-group col-md-12">
                        <div class="clearfix">&nbsp;</div>
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" name="cobrar" class="custom-control-input" v-model="model.cobrar">
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description"> Cobrar?</span>
                        </label>
                    </div>
					<div class="form-group col-md-12">
                        <label for="statusUsoBox">StatusUsoBox</label>
                        <input type="text" class="form-control" name="statusUsoBox" placeholder="StatusUsoBox" v-model="model.statusUsoBox" required />
                    </div>
					<div class="form-group col-md-12">
                        <label for="emailEnvio">EmailEnvio</label>
                        <input type="text" class="form-control" name="emailEnvio" placeholder="EmailEnvio" v-model="model.emailEnvio"  />
                    </div>
					<div class="form-group col-md-12">
                        <label for="passwordEnvio">PasswordEnvio</label>
                        <input type="text" class="form-control" name="passwordEnvio" placeholder="PasswordEnvio" v-model="model.passwordEnvio"  />
                    </div>
					<div class="form-group col-md-12">
                        <div class="clearfix">&nbsp;</div>
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" name="sinalizarInadimplencia" class="custom-control-input" v-model="model.sinalizarInadimplencia">
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description"> SinalizarInadimplencia?</span>
                        </label>
                    </div>
					<div class="form-group col-md-12">
                        <div class="clearfix">&nbsp;</div>
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" name="inadimplente" class="custom-control-input" v-model="model.inadimplente">
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description"> Inadimplente?</span>
                        </label>
                    </div>
					<div class="form-group col-md-12">
                        <div class="clearfix">&nbsp;</div>
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" name="mostrarAviso" class="custom-control-input" v-model="model.mostrarAviso">
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description"> MostrarAviso?</span>
                        </label>
                    </div>
					<div class="form-group col-md-12">
                        <div class="clearfix">&nbsp;</div>
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" name="bloquearSistema" class="custom-control-input" v-model="model.bloquearSistema">
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description"> BloquearSistema?</span>
                        </label>
                    </div>
					<div class="form-group col-md-12">
                        <div class="clearfix">&nbsp;</div>
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" name="temCnaTalk" class="custom-control-input" v-model="model.temCnaTalk">
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description"> TemCnaTalk?</span>
                        </label>
                    </div>
					<div class="form-group col-md-12">
                        <label for="planoServicoId">PlanoServicoId</label>
                        <input type="text" class="form-control" name="planoServicoId" placeholder="PlanoServicoId" v-model="model.planoServicoId"  />
                    </div>
					<div class="form-group col-md-12">
                        <label for="tipoImplantacaoId">TipoImplantacaoId</label>
                        <input type="text" class="form-control" name="tipoImplantacaoId" placeholder="TipoImplantacaoId" v-model="model.tipoImplantacaoId"  />
                    </div>


        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeCreate(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>
    
	import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "escolabox-form-create",
        mixins: [base],
        data: () => ({

            model: {},

            form: "escolabox-form-create",
            
            resources: {
                create: 'escolabox',
            },

        }),
		
        methods: {

            executeCreate: function (model) {

                if (this.formValidate() == false)
                    return;

                new Api(this.resources.create).post(model).then(data => {
                    this.$emit('on-saved', data)
                    this.defaultSuccessResult('Registro inserido com sucesso');
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },
    };
</script>

